import {useNeoContext} from "@/context/neo/neo.context";
import {FleetService} from "@/service/fleet.service";
import React, {useEffect, useState} from "react";
import GenericWidget from "../widgets/GenericWidget";
import WidgetData from "../widgets/Widget-data";

const VendorWidget: React.FC = () => {
  const {filterContext} = useNeoContext();
  const [loginUserId, setLoginUserId] = useState("");

  useEffect(() => {
    if (filterContext?.client?.institutionUserId) {
      setLoginUserId(filterContext.client.institutionUserId);
    }
  }, [filterContext]);

  return (
    <GenericWidget
      title="Vendor List"
      icon="/images/vendor_yellow.svg"
      type={2}
      fetchService={FleetService.getfleetdatas}
      addService={FleetService.addfleetdata}
      updateService={FleetService.updatefleetdata}
      deleteService={FleetService.deletefleetdata}
      renderEmptyImage="/images/vendorGroup.svg"
      emptyText="No vendor added yet"
      actionText="Vendor"
      WidgetContent={WidgetData}
      loginUserId={loginUserId}
      apiresponsekey="vendors"
    />
  );
};

export default VendorWidget;
